module.exports = __webpack_public_path__ + "static/carnegie-gl-191c52e66a60d9edfae57f9b0200de94.jpg";